import { logger } from '@myrealtrip/nextjs';
import { useQuery } from '@tanstack/react-query';

import { channelTalkApi } from '~endpoints/ChannelTalk';
import { useWebView } from '@myrealtrip/device-detect';
import { channelTalkKeys } from '~queryKeys/channelTalkKeys';
import { RequestParams } from '~utils/https/HttpClientFetch';

export async function fetchMemberHash(params: RequestParams = {}) {
  try {
    return (await channelTalkApi.v1.memberHash(params)) || null;
  } catch (error) {
    logger.error(error);
    return null;
  }
}

export function useMemberHash() {
  const { isWebView } = useWebView();

  return useQuery({
    queryKey: channelTalkKeys.memberHash(),
    queryFn: () => channelTalkApi.v1.memberHash(),
    select: (response) => response?.data ?? null,
    enabled: !isWebView,
  });
}
